export class OrderQuantity {
	id: string;
	quantity: string;
}